import { render, staticRenderFns } from "./ToggleButtonWrapper.vue?vue&type=template&id=f140c1a2&scoped=true"
import script from "./ToggleButtonWrapper.vue?vue&type=script&lang=js"
export * from "./ToggleButtonWrapper.vue?vue&type=script&lang=js"
import style0 from "./ToggleButtonWrapper.vue?vue&type=style&index=0&id=f140c1a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f140c1a2",
  null
  
)

export default component.exports